import { action } from 'typesafe-actions';
import {
  CHANNELS_FAILURE,
  CHANNELS_REQUEST,
  CHANNELS_SUCCESS,
} from '../../constants/channels';

export const channelsRequestAction = (tipsterID: string) =>
  action(CHANNELS_REQUEST, tipsterID);
export const channelsSuccessAction = (data: any) =>
  action(CHANNELS_SUCCESS, data);
export const channelsFailureAction = (e: any) => action(CHANNELS_FAILURE, e);

export const channelsActions = {
  channelsRequestAction,
  channelsSuccessAction,
  channelsFailureAction,
};
